import {
  CustomButton,
  CustomImage,
  CustomModal,
  errorDialog,
  Text,
  useText,
} from '@src/components';
import modalClose from '@src/assets/icons/icon-close.svg';
import React, { useCallback, useState } from 'react';
import { Radio } from 'antd';
import '@src/styles/vehicleManagement/downloadFileModal.scss';
import { useSelector } from 'react-redux';
import download from 'js-file-download';
import vehicleManagementService from '@src/services/vehicleManagement/vehicleManagement.services';
import PropTypes from 'prop-types';

const DownloadFileModal = ({ modalVisible, handleModalVisible, fileName }) => {
  const [selectedValue, setSelectedValue] = useState(undefined);
  const { selectedCustomer } = useSelector((state) => state?.customer);
  const [loading, setLoading] = useState(false);
  const { isAdmin } = useSelector((state) => state.auth);
  const { selectedUserId } = useSelector((state) => state.user);

  const handleClose = useCallback(
    (e) => {
      e.preventDefault();
      setSelectedValue(null);
      handleModalVisible(false);
    },
    [handleModalVisible],
  );

  const onChange = useCallback((e) => {
    setSelectedValue(e.target.value);
  }, []);

  const handleDownload = async () => {
    const customerId = isAdmin && selectedUserId ? selectedUserId : selectedCustomer?.customerId;
    setLoading(true);
    try {
      if (selectedValue === 'pdf') {
        await pdfDownload(customerId);
      }
      if (selectedValue === 'excel') {
        await excelDownload(customerId);
      }
    } finally {
      setLoading(false);
    }
  };
  const pdfDownload = useCallback(async (customerId) => {
    let data = {
      customerId,
    };

    try {
      const currentDate = new Date().toISOString().split('T')[0];
      const blob = await vehicleManagementService.getVehicleSummaryPdfReport(data);
      download(blob, `${fileName}-${currentDate}.pdf`);
      handleModalVisible(!blob);
    } catch (error) {
      errorDialog({
        title: <Text t="error" />,
        message: error?.statusText,
      });
    }
  }, []);

  const excelDownload = useCallback(
    async (customerId) => {
      let data = {
        customerId,
        downloadType: 2,
      };

      try {
        const currentDate = new Date().toISOString().split('T')[0];
        const blob = await vehicleManagementService.getDownloadVehicleFile(data);
        download(blob, `${fileName}-${currentDate}.xlsx`);
        handleModalVisible(!blob);
      } catch (error) {
        errorDialog({
          title: <Text t="error" />,
          message: error?.statusText,
        });
      }
    },
    [handleModalVisible],
  );
  return (
    <CustomModal
      className="download-file-modal"
      maskClosable={false}
      footer={false}
      title={useText('download')}
      visible={modalVisible}
      onCancel={handleClose}
      closeIcon={<CustomImage src={modalClose} />}
    >
      <div className="download-container" data-testid="download-file-modal-test-id">
        <Radio.Group
          id="downloadModal-custom-radioGroup-input-content"
          onChange={onChange}
          value={selectedValue}
          className="custom-radio-input-content"
        >
          <Radio
            id="downloadModal-custom-radio-input-content-pdf"
            data-testid="pdf"
            value="pdf"
            className="custom-radio-input"
          >
            PDF
          </Radio>
          <Radio
            id="downloadModal-custom-radio-input-content-excel"
            data-testid="excel"
            value="excel"
            className="custom-radio-input"
          >
            Excel
          </Radio>
        </Radio.Group>
        <div className="footer-btn">
          <CustomButton
            id="downloadModal-download-btn"
            data-testid="download"
            className="download-btn"
            loading={loading}
            onClick={handleDownload}
          >
            <Text t="download" />
          </CustomButton>
          <CustomButton
            id="downloadModal-cancel-btn"
            data-testid="cancel"
            className="cancel-btn"
            onClick={handleClose}
          >
            <Text t="giveUp" />
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
};

DownloadFileModal.propTypes = {
  modalVisible: PropTypes.bool,
  handleModalVisible: PropTypes.func,
  fileName: PropTypes.string.isRequired,
};

export default DownloadFileModal;
